import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";
import styles from "./HeroSection.module.css";

interface Props {
  title: string;
  content: React.ReactNode;
}
function HeroSection({ title, content = <></> }: Props) {
  const { institution } = useGetInstitutionQuery();

  return (
    <div className={styles.heroSectionContainer}>
      <div className={styles.heroSection}>
        <div className={styles.heroSectionContent}>
          <div className={styles.institutionLogoContainer}>
            <span
              className={styles.institutionLogo}
              style={{
                backgroundImage: `url(${institution.lending_welcome_screen_logo_url})`,
              }}
            />
          </div>
          <div className={styles.heroSectionTitleContainer}>
            <h1 className="fontSize--heading0" style={{ color: "white", whiteSpace: "pre-line" }}>
              {title}
            </h1>
          </div>
          {content}
        </div>
      </div>
    </div>
  );
}

export { HeroSection };
